import { Dialog, Transition } from "@headlessui/react"
import { FC, Fragment, useCallback, useMemo, useState } from "react"
import { OpenCloseRender, OverlayProps } from "../types"

export type { OpenCloseRender }

export const InlineOverlay: FC<OverlayProps> = ({ onOpen, onClose, render, renderButton }) => {
  let [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => {
    setIsOpen(true)
    onOpen ? onOpen() : null
  }, [onOpen])

  const close = useCallback(() => {
    setIsOpen(false)
    onClose
      ? setTimeout(() => {
          onClose()
        }, 200)
      : null
  }, [onClose])
  const renderedButton = useMemo(() => renderButton({ open, close }), [renderButton, open, close])
  const rendered = useMemo(() => render({ open, close }), [render, open, close])
  return <>{isOpen ? rendered : renderedButton}</>
}
export default InlineOverlay
